export function getDocumentRepairLogsRequest(
  {
    limit,
    page,
    clientId,
    yourNumber,
    documentType,
    documentFixGroup,
    repairResult,
    initialDate,
    finalDate,
  } = {},
  onSuccess
) {
  return {
    type: '@documentRepairLogs/GET_REQUEST',
    payload: {
      limit,
      page,
      clientId,
      yourNumber,
      documentType,
      documentFixGroup,
      repairResult,
      initialDate,
      finalDate,
      onSuccess,
    },
  };
}

export function getDocumentRepairLogsSuccess(data) {
  return {
    type: '@documentRepairLogs/GET_SUCCESS',
    payload: { data },
  };
}

export function documentRepairLogsFailure() {
  return {
    type: '@documentRepairLogs/FAILURE',
  };
}
